<template>
  <v-btn v-bind="$attrs" :color="getColor" :disabled="(!isDoctorRecord && time.disable) || !time.schedule" @click="toggleTime">
    {{ time.time }}
  </v-btn>
</template>

<script>
import { ScheduleRepository } from "@/modules/schedule/schedule.repository.js";
import { Doctor } from "@/modules/doctors/Doctor.js";
import ScheduleAppointment from "@/modules/schedule/ScheduleAppointment.vue";

export default {
  name: "ScheduleTimeButton",

  props: {
    doctor: {
      type: Doctor,
      required: true,
    },
    time: {
      type: Object,
      required: true,
    },
    eventId: {
      type: String,
      default: null,
    },
  },

  computed: {
    isDoctorRecord() {
      return this.time.disable && this.time.schedule.author_id === this.$store.state.auth.id;
    },

    getColor() {
      if (this.isDoctorRecord) {
        return "success";
      }

      return "info";
    },
  },

  methods: {
    toggleTime() {
      if (this.isDoctorRecord) {
        this.closeTime();
        return;
      }

      this.openTime();
    },

    /**
     * Открывает время на запись
     */
    async openTime() {
      const result = await this.$dialog.showAndWait(ScheduleAppointment, {
        doctor: this.doctor,
        time: this.time,
      });

      if (!result) {
        return;
      }

      console.log(
        `this.doctor.id,
      this.$store.state.customer.id, =>`,
        this.doctor.id,
        this.$store.state.customer.id,
      );

      const { success, message } = await ScheduleRepository.appointment(
        this.doctor.id,
        this.$store.state.customer.id,
        this.time.schedule.start_at,
        // тут результат будет на минуту меньше чем промежутки на беке, добавляем 1 минуту
        this.$date(this.time.schedule.end_at).diff(this.$date(this.time.schedule.start_at), "minute") + 1,
        result.providingWay,
        this.eventId,
        result.additionalDoctors,
      );

      if (success) {
        this.$dialog.notify.success(`Запись создана`);
        this.$emit("update");
        return;
      }

      this.$dialog.notify.error(message);
    },

    /**
     * Закрывает время на запись
     */
    async closeTime() {
      const result = await this.$dialog.confirm({
        title: "Вы действительно хотите отменить запись?",
        text: `У доктора ${this.doctor.fullName}, ${this.$date.unix(this.time.ts).format("DD.MM.YYYY")} в ${this.time.time}`,
      });
      if (!result) {
        return;
      }

      const { success, message } = await ScheduleRepository.cancelAppointment(this.time.schedule.entity_id);

      if (success) {
        this.$dialog.notify.success(`Консультация отменена`);
        this.$emit("update");
        return;
      }

      this.$dialog.notify.error(message);
    },
  },
};
</script>

<style scoped></style>
